import React from 'react';
import { Paper, Box, Tabs, Tab } from '@mui/material';
import TabPanel from '../../../components/common/tabs/TabPanel';
import ProjectDetailInfoContainer from '../detail/ProjectDetailInfoContainer';
import SalesActivityTemplate from '../../../components/techmng/stepper/SalesActivityTemplate';
import ProjectFileTemplate from '../../../components/techmng/stepper/ProjectFileTemplate';
import TechSupportTemplate from '../../../components/techmng/stepper/TechSupportTemplate';
import ProjectTechFileTemplate from '../../../components/techmng/stepper/ProjectTechFileTemplate';

function a11yProps(index) {
  return {
    id: `tech-tab-${index}`,
    'aria-controls': `tech-tabpanel-${index}`,
  };
}

const TechStepFirstContainer = ({ activeTap, handleTabChange }) => {
  return (
    <Paper
      sx={{
        mt: 1,
        pb: 1,
      }}
    >
      <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTap}
          onChange={handleTabChange}
          aria-label="기술 지원 관리"
        >
          <Tab label="기본사항" {...a11yProps(0)} />
          <Tab label="영업활동" {...a11yProps(1)} />
          <Tab label="영업파일" {...a11yProps(2)} />
          <Tab label="기술지원" {...a11yProps(3)} />
          <Tab label="기술파일" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <TabPanel value={activeTap} index={0}>
        <ProjectDetailInfoContainer />
      </TabPanel>
      <TabPanel value={activeTap} index={1}>
        <SalesActivityTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={2}>
        <ProjectFileTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={3}>
        <TechSupportTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={4}>
        <ProjectTechFileTemplate />
      </TabPanel>

      <Box sx={{ width: '100%', borderTop: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTap}
          onChange={handleTabChange}
          aria-label="기술 지원 관리"
          TabIndicatorProps={{ style: { top: 0 } }}
        >
          <Tab label="기본사항" {...a11yProps(0)} />
          <Tab label="영업활동" {...a11yProps(1)} />
          <Tab label="영업파일" {...a11yProps(2)} />
          <Tab label="기술지원" {...a11yProps(3)} />
          <Tab label="기술파일" {...a11yProps(4)} />
        </Tabs>
      </Box>
    </Paper>
  );
};

export default TechStepFirstContainer;
